import React, { useEffect, useContext, useState } from 'react';
import FundContext from '@/components/FundSingle/FundProvider';

export interface RiskMeterProps {
  rating: number;
}

const RiskMeter: React.FC<RiskMeterProps> = ({ rating }) => {
  const { fundRiskDetails, currentTabIndex, hasInitCharts } = useContext(FundContext);

  useEffect(() => {

    if (Object.keys(fundRiskDetails).length === 0) {
      return;
    }
    
    function initRiskmeter() {
      // Once the script is loaded, we can initialize the chart
      const riskChartData = {
        datasets: [
          {
            data: [rating, 7 - rating],
            backgroundColor: [
              "#001E63", "white"
            ],
            borderColor: "black",
            borderWidth: 2,
          }
        ]
      };

      const riskChartOptions = {
        rotation: -90,
        cutout: '50%',
        circumference: 180,
        responsive: false,
        legend: { position: 'left' },
        maintainAspectRatio: false,
        aspectRatio: 2,
        animation: { animateRotate: true, animateScale: true },
        events: [],
      };

      const config = {
        type: 'doughnut',
        data: riskChartData,
        options: riskChartOptions
      };

      const ctx = document.getElementById('riskMeterContainer') as HTMLCanvasElement;

      if (!ctx) {
          return;
      }

      // Clear the container
      ctx.innerHTML = '';
      
      // Create canvas element for the chart
      var canvas = document.createElement('canvas');
      canvas.id = 'barContainer';
      document.getElementById('riskMeterContainer').appendChild(canvas);

      new Chart(canvas, config);
    }
    
    // Wait for the chartjs script to load
    if (hasInitCharts) {
      initRiskmeter();
    } else {
      window.addEventListener('chartjsLoaded', () => {
        initRiskmeter();
      });
    }

  }, [fundRiskDetails]);

  return <div id="riskMeterContainer"></div>;
};

export default RiskMeter;
